import { render, staticRenderFns } from "./Sertifikat.vue?vue&type=template&id=6501dbd5&scoped=true&"
var script = {}
import style0 from "./Sertifikat.vue?vue&type=style&index=0&id=6501dbd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6501dbd5",
  null
  
)

export default component.exports